import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';
//import 'jquery-validation';
//import 'jquery-validation-unobtrusive';

class Validation {
    constructor() {
        
    }

    init() {
        this.bindEvents();
    }

	bindEvents() {
		if ($('.js-form').validate) { // only run if jQuery Validate exists
			$('.js-form').validate();

			$('.js-form').on('click.validate focusin.validate focusout.validate keyup.validate', e => this.onFormChanged(e));
			$('.js-form').on('focusout.validate', e => this.onFormBlurred(e));
		}
    }

    onFormBlurred(e) {
        $(e.target).valid();
        this.onFormChanged(e);
    }

    onFormChanged(e) {
        let target = $(e.currentTarget);
        let children = $(target).find('.form-control');

		$(children).each((i, el) => {
			let field = $(el);
			let group = field.closest('.form-group');

			group.removeClass('form-error').removeClass('form-success');

			if (field.hasClass('input-validation-error') && !field.hasClass('valid')) {
				group.addClass('form-error');
			}
			else if ($(field).val() !== '' && !field.hasClass('input-validation-error') && field.hasClass('valid')) {
				group.addClass('form-success');
			}

			group.find('.form-error-desc').removeAttr('style');
		});
    }
}

export default Validation;